// ************ FORM INITIALIZE MATRIX- START ************ //
import {MatrixInitializationValues} from "../../../api/types/rateDetail";
import * as yup from "yup";
import {maxNumberYupLimit, minNumberYupLimit} from "../../../constants";

export const initialValues: MatrixInitializationValues = {
    matrixInitializationType: 0,
    carGroups: [],
    rentalPeriods: [],
    rate: null,
    discountIncreasePercentage: null,
    discountIncreaseFixed: null,
    excelFile: null,
    absolute: false
};

export const validationSchema = ({t}: { t: Function }) => yup.object().shape({
    carGroups: yup
        .array().of(yup.string())
        .nullable()
        .when("matrixInitializationType", {
            is: 0,
            then: yup
                .array().of(yup.string())
                .nullable()
                .min(1, t("translation:validation.atLeastOneRequired"))
        }),
    rentalPeriods: yup
        .array().of(yup.object().shape({
            code: yup.string(),
            label: yup.string()
        }))
        .nullable()
        .when("matrixInitializationType", {
            is: 0,
            then: yup
                .array().of(yup.object().shape({
                    code: yup.string(),
                    label: yup.string()
                }))
                .nullable()
                .min(1, t("translation:validation.atLeastOneRequired"))
        }),
    rate: yup
        .object().shape({
            code: yup.string(),
            label: yup.string()
        })
        .nullable()
        .when("matrixInitializationType", {
            is: 1,
            then: yup
                .object().shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        }),
    discountIncreasePercentage: yup
        .number()
        .integer()
        .nullable()
        .typeError(t("pricing:alert.errors.integer"))
        .min(-99, t("pricing:validation.numberGreaterThan") + -99)
        .max(100, t("pricing:validation.numberLowerThan") + 100),
    discountIncreaseFixed: yup
        .number()
        .transform((o, v) => v ? parseFloat(v.replace(/,/g, ".")) : v)
        .nullable()
        .min(minNumberYupLimit, t("pricing:validation.numberGreaterThan") + minNumberYupLimit)
        .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit),
    excelFile: yup
        .mixed()
        .nullable()
        .when("matrixInitializationType", {
            is: 2,
            then: yup
                .mixed()
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        }),
    absolute: yup.boolean()
});
// ************ FORM INITIALIZE MATRIX - END ************ //